import React from "react";

export const RemoteWorkerSvg = ({ className }) => (
  <svg className={className} width="552" height="313" viewBox="0 0 552 313" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M320.343 311.274L320.228 311.272C319.299 311.254 318.581 310.448 318.669 309.523L324.87 243.97L330.279 244.482L321.376 310.389C321.308 310.903 320.862 311.283 320.343 311.274Z"
      fill="#5F8AD4"
    />
    <path
      d="M380.041 311.274L380.156 311.272C381.086 311.254 381.803 310.448 381.715 309.523L375.515 243.97L370.105 244.482L379.008 310.389C379.077 310.903 379.523 311.283 380.041 311.274Z"
      fill="#5F8AD4"
    />
    <path
      d="M276.605 311.274L276.49 311.272C275.56 311.254 274.843 310.448 274.931 309.523L281.131 243.97L286.541 244.482L277.638 310.389C277.57 310.903 277.124 311.283 276.605 311.274Z"
      fill="#2B5AE1"
    />
    <path d="M378.195 237.59L403.548 146.602H347.548L323.552 234.433L378.195 237.59Z" fill="#5F8AD4" />
    <path
      d="M378.021 244.928H288.261C288.166 244.928 288.087 244.851 288.087 244.753V234.606C288.087 234.511 288.164 234.431 288.261 234.431H378.021C378.116 234.431 378.195 234.508 378.195 234.606V244.753C378.195 244.851 378.118 244.928 378.021 244.928Z"
      fill="#5F8AD4"
    />
    <path
      d="M326.036 244.928H262.503C262.408 244.928 262.328 244.851 262.328 244.753V234.606C262.328 234.511 262.405 234.431 262.503 234.431H326.036C326.131 234.431 326.21 234.508 326.21 234.606V244.753C326.208 244.851 326.131 244.928 326.036 244.928Z"
      fill="#2B5AE1"
    />
    <path
      d="M395.94 183.685C395.214 187.85 393.169 191.504 393.039 191.833C391.931 194.583 385.845 179.5 385.845 179.5L384.936 173.689L383.459 164.252L383.043 161.603L381.39 151.043L381.798 149.438L383.785 141.637L383.606 139.857C383.606 139.857 389.74 143.25 391.41 149.692C392.001 151.972 392.856 156.807 393.666 162.215C393.792 163.063 394.505 163.411 394.631 164.281C395.675 171.643 396.576 180.047 395.94 183.685Z"
      fill="#FF8585"
    />
    <path
      d="M283.763 192.643C283.763 192.643 285.467 191.734 286.962 191.605C295.397 190.879 313.683 184.623 315.62 183.191C319.192 180.546 334.118 167.992 340.003 161.656C340.007 161.652 344.931 155.866 344.931 155.866C350.5 149.873 345.45 139.412 345.45 139.412C345.45 139.412 335.887 143.471 332.429 147.467C330.171 150.074 312.889 171.473 310.731 172.524C303.703 175.95 283.778 187.641 281.7 188.559C281.696 188.555 278.998 190.429 283.763 192.643Z"
      fill="#FC9490"
    />
    <path
      d="M231.189 296.117C231.189 296.117 232.346 311.111 229.771 311.309C229.429 311.336 216.719 311.336 216.719 311.336L200.495 311.236C200.495 311.236 200.601 307.159 205.344 306.296C210.087 305.433 219.473 301.27 222.345 294.731C225.368 287.852 231.189 296.117 231.189 296.117Z"
      fill="#163560"
    />
    <path
      d="M344.105 204.042C344.105 204.042 342.677 231.223 340.188 235.958C340.188 235.958 339.076 235.568 330.954 235.495C321.127 235.406 274.196 235.219 268.567 238.066C266.808 238.958 261.76 260.141 231.612 296.591C231.612 296.591 228.611 298.609 224.028 298.276C219.654 297.958 219.287 297.148 219.287 297.148C219.287 297.148 247.967 223.857 254.319 217.822C264.021 208.599 313.688 199.113 320.957 198.901C328.223 198.689 344.105 204.042 344.105 204.042Z"
      fill="#F2564B"
    />
    <path
      d="M264.825 296.75C264.825 296.75 265.982 311.119 263.408 311.309C263.065 311.335 250.356 311.335 250.356 311.335L234.132 311.24C234.132 311.24 234.238 307.331 238.981 306.505C243.723 305.68 253.11 301.689 255.982 295.422C259.005 288.83 264.825 296.75 264.825 296.75Z"
      fill="#163560"
    />
    <path
      d="M362.774 204.042C362.774 204.042 362.379 211.557 361.644 219.371C360.736 228.998 354.766 235.117 345.145 236.122C338.669 236.797 331.014 236.44 325.958 236.411C301.573 236.274 292.864 235.217 287.236 238.064C285.476 238.956 293.847 252.322 265.306 296.589C265.306 296.589 263.154 298.311 258.384 298.989C255.538 299.393 252.255 298.311 252.255 298.311C252.255 298.311 261.113 228.7 268.329 220.649C273.489 214.892 314.408 208.142 321.674 207.93C328.939 207.72 362.774 204.042 362.774 204.042Z"
      fill="#FB7369"
    />
    <path
      d="M395.94 165.511C395.94 165.511 390.942 170.036 382.602 169.255C382.129 171.67 381.54 174.356 380.851 177.199C380.794 177.436 380.736 177.674 380.676 177.912C379.59 182.336 378.272 187.115 376.79 191.831C372.491 205.528 366.824 218.718 361.451 221.312C360.888 221.583 344.925 221.433 333.997 217.184C330.833 215.954 327.793 214.069 325.046 211.985C321.063 208.961 317.698 205.517 315.492 203.045C313.907 201.268 314.068 198.541 315.847 196.956C319.961 193.29 326.81 186.813 328.351 183.016C329.652 179.813 331.571 173.076 333.103 167.369C325.028 165.228 323.185 156.447 323.185 156.447C323.185 156.447 336.406 142.056 340.546 139.407C345.967 135.944 353.136 135.5 355.945 135.019C362.836 133.836 370.952 134.041 383.609 139.853C383.609 139.853 390.776 143.727 392.684 151.2C394.591 158.674 395.94 165.511 395.94 165.511Z"
      fill="#1C468A"
    />
    <path
      d="M363.099 145.403C356.307 145.917 355.718 140.434 355.718 140.434L355.872 136.798L356.051 132.526C356.051 132.526 360.971 129.933 364.848 128.134C367.323 126.988 369.376 126.167 369.458 126.551C370.026 129.209 371.662 134.502 373.362 136.884C374.355 141.01 369.893 144.886 363.099 145.403Z"
      fill="#FF8585"
    />
    <path
      d="M353.538 133.679C353.538 133.679 370.597 135.222 371.394 124.586C372.191 113.95 374.929 106.986 364.072 105.553C353.216 104.118 350.791 108.019 349.663 111.505C348.532 114.988 349.122 133.003 353.538 133.679Z"
      fill="#FF9591"
    />
    <path
      d="M377.451 104.82C377.607 104.641 377.97 104.498 378.775 104.456C378.775 104.456 378.135 104.052 377.274 104.028C377.111 102.909 376.521 100.926 374.598 100.438C374.598 100.438 375.631 100.995 375.762 102.182C373.54 99.8844 368.769 98.2 355.532 99.1956C338.089 100.507 343.794 111.69 346.046 113.03C348.298 114.37 353.995 110.743 358.199 111.092C362.403 111.441 363.18 117.52 364.605 118.359C366.029 119.198 365.472 117.721 367.406 116.856C369.341 115.99 369.513 119.189 368.945 121.266C368.38 123.343 371.023 126.096 371.023 126.096C371.023 126.096 371.023 126.096 373.715 123.22C376.406 120.343 378.979 108.127 377.769 105.518C377.667 105.288 377.561 105.054 377.451 104.82Z"
      fill="#2C3A64"
    />
    <path
      d="M351.606 127.405C351.606 127.405 352.189 129.12 354.097 129.12C356.804 129.12 357.868 127.257 357.868 127.257C357.868 127.257 354.207 126.348 351.606 127.405Z"
      fill="white"
    />
    <path
      d="M360.122 133.476C360.122 133.476 358.771 131.231 360.122 130.778C367.057 128.454 369.084 129.765 369.084 129.765L360.122 133.476Z"
      fill="#FF8585"
    />
    <path
      d="M371.386 139.823C371.386 139.823 371.997 129.558 368.389 129.637C364.784 129.714 360.33 130.865 360.16 131.783C359.681 134.363 363.839 143.109 365.901 143.498C367.963 143.886 371.386 139.823 371.386 139.823Z"
      fill="#FC9490"
    />
    <path
      d="M380.679 177.913C379.593 182.336 378.275 187.116 376.793 191.831C372.494 205.528 366.826 218.718 361.454 221.312C360.891 221.583 344.927 221.433 334 217.184C330.836 215.954 327.796 214.069 325.049 211.985C332.368 214.186 344.42 212.129 355.72 208.272C367.827 204.138 368.421 189.193 368.421 189.193C371.92 180.924 367.367 152.606 367.367 152.606L380.679 177.913Z"
      fill="#143D7A"
    />
    <path
      d="M365.396 143.242C365.396 143.242 375.093 195.941 387.906 195.972C392.843 195.983 398.886 183.16 392.366 175.862C383.007 165.385 371.386 139.822 371.386 139.822C371.386 139.822 369.761 138.8 365.396 143.242Z"
      fill="#FC9490"
    />
    <path
      d="M281.696 188.555C281.696 188.555 277.653 189.241 275.54 188.555C273.427 187.868 260.51 192.848 262.063 192.967C263.613 193.087 271.352 191.943 273.156 192.096C274.96 192.248 275.922 192.332 275.216 192.976C274.509 193.621 269.499 193.802 271.248 194.358C272.997 194.914 277.291 194.756 279.119 194.358C280.948 193.961 282.933 193.082 284.14 192.458C285.496 191.756 281.696 188.555 281.696 188.555Z"
      fill="#FC9490"
    />
    <path d="M266.758 196.206H299.189C299.189 194.778 298.032 193.621 296.603 193.621H266.758V196.206Z" fill="#B24940" />
    <path d="M266.85 160.893H216.711L228.738 196.206H279.202L266.85 160.893Z" fill="#B24940" />
    <path d="M215.974 160.893L227.998 196.206H278.464L266.113 160.893H215.974Z" fill="#FB7369" />
    <path
      d="M243.006 178.223C243.317 179.572 244.664 180.667 246.013 180.667C247.362 180.667 248.203 179.572 247.892 178.223C247.581 176.875 246.234 175.78 244.885 175.78C243.536 175.78 242.692 176.872 243.006 178.223Z"
      fill="#FB7369"
    />
    <path
      d="M91.8486 260.821C91.8486 260.821 99.9607 251.357 92.3498 245.349C92.3498 245.349 86.79 241.982 82.2548 242.256C82.2548 242.256 88.6801 253.026 86.6001 254.097C84.5224 255.168 80.3073 241.58 80.3073 241.58C80.3073 241.58 67.6533 240.353 63.5839 242.311C63.5839 242.311 74.4009 251.161 72.1223 251.689C69.8436 252.216 58.1589 243.53 58.1589 243.53C58.1589 243.53 46.3814 245.534 47.0107 252.717C47.6377 259.9 51.6961 262.117 53.4801 261.927C55.2642 261.735 65.697 257.755 65.9244 259.214C66.1518 260.675 59.8723 265.45 55.4739 265.673C55.4739 265.673 63.7782 274.827 69.296 272.185C74.8138 269.543 75.2863 265.355 78.7242 263.783C82.1643 262.212 85.1009 262.216 83.6812 263.819C82.2614 265.421 76.0349 266.978 74.0675 270.457C72.1002 273.936 70.336 276.282 76.0437 275.423C81.7536 274.565 91.0338 270.388 91.4401 265.605C91.8486 260.821 91.8486 260.821 91.8486 260.821Z"
      fill="#5F8AD4"
    />
    <path
      d="M52.7979 252.907C52.7979 252.907 84.7852 251.675 91.8485 260.821C91.8485 260.821 93.4118 265.499 98.2186 269.759L98.9671 271.801C98.9671 271.801 93.4251 265.958 91.4401 265.605C91.4401 265.602 94.5423 254.271 52.7979 252.907Z"
      fill="#5F8AD4"
    />
    <path
      d="M98.2182 269.757C98.2182 269.757 105.085 274.834 105.562 283.904L104.317 284.015C104.317 284.015 102.124 274.635 98.1608 270.968C94.1952 267.302 98.2182 269.757 98.2182 269.757Z"
      fill="#5F8AD4"
    />
    <path
      d="M120.213 248.92C120.213 248.92 107.307 241.695 113.33 231.889C113.33 231.889 118.148 225.867 123.31 224.32C123.31 224.32 120.557 238.942 123.31 239.287C126.064 239.631 125.203 222.772 125.203 222.772C125.203 222.772 138.797 216.236 144.13 216.75C144.13 216.75 135.697 231.028 138.451 230.684C141.204 230.34 150.667 215.89 150.667 215.89C150.667 215.89 164.604 213.309 166.841 221.567C169.078 229.825 165.463 233.953 163.399 234.47C161.334 234.987 148.084 234.814 148.429 236.534C148.773 238.254 157.72 241.006 162.71 239.459C162.71 239.459 157.203 253.05 149.976 252.362C142.75 251.673 140.513 247.201 136.039 246.856C131.566 246.512 128.296 247.717 130.533 248.92C132.769 250.123 140.341 249.315 143.955 252.386C147.57 255.457 150.493 257.351 143.783 258.726C137.073 260.103 125.028 259.242 122.619 254.081C120.213 248.92 120.213 248.92 120.213 248.92Z"
      fill="#5F8AD4"
    />
    <path
      d="M160.477 224.147C160.477 224.147 124.343 235.845 120.212 248.92C120.212 248.92 120.384 254.77 116.77 261.478V264.059C116.77 264.059 120.554 255.286 122.621 254.081C122.621 254.081 114.535 242.726 160.477 224.147Z"
      fill="#5F8AD4"
    />
    <path
      d="M116.772 261.478C116.772 261.478 111.199 269.94 114.377 280.238L115.81 279.854C115.81 279.854 114.418 268.511 117.333 262.805C120.25 257.099 116.772 261.478 116.772 261.478Z"
      fill="#5F8AD4"
    />
    <path
      d="M99.6825 238.956C99.6825 238.956 116.695 229.431 108.755 216.506C108.755 216.506 102.405 208.57 95.5999 206.528C95.5999 206.528 99.2299 225.804 95.5999 226.256C91.97 226.709 93.1049 204.486 93.1049 204.486C93.1049 204.486 75.187 195.868 68.1545 196.55C68.1545 196.55 79.2696 215.371 75.6396 214.919C72.0097 214.466 59.5345 195.415 59.5345 195.415C59.5345 195.415 41.1617 192.014 38.214 202.899C35.2664 213.784 40.029 219.225 42.7515 219.907C45.4739 220.587 62.9392 220.36 62.4844 222.629C62.0317 224.896 50.2366 228.525 43.659 226.484C43.659 226.484 50.9166 244.397 60.4442 243.49C69.9695 242.583 72.9194 236.687 78.8169 236.234C84.7145 235.781 89.0245 237.369 86.0746 238.956C83.1269 240.543 73.1468 239.477 68.3819 243.525C63.6193 247.574 59.7619 250.068 68.6094 251.883C77.4568 253.697 93.3323 252.563 96.5074 245.759C99.6825 238.956 99.6825 238.956 99.6825 238.956Z"
      fill="#2B5AE1"
    />
    <path
      d="M46.6064 206.3C46.6064 206.3 94.2396 221.72 99.6823 238.956C99.6823 238.956 99.4549 246.666 104.22 255.51V258.911C104.22 258.911 99.2297 247.346 96.5072 245.759C96.5072 245.759 107.167 230.792 46.6064 206.3Z"
      fill="#7DB6FD"
    />
    <path
      d="M104.218 255.51C104.218 255.51 111.564 266.662 107.375 280.238L105.485 279.73C105.485 279.73 107.32 264.777 103.476 257.258C99.6338 249.737 104.218 255.51 104.218 255.51Z"
      fill="#7DB6FD"
    />
    <path d="M100.255 309.677C81.8511 309.677 66.9316 294.761 66.9316 276.362H133.578C133.578 294.761 118.658 309.677 100.255 309.677Z" fill="#2B5AE1" />
    <path d="M66.4717 311.373H134.039C134.039 309.103 132.197 307.262 129.927 307.262H70.583C68.3132 307.262 66.4717 309.101 66.4717 311.373Z" fill="#2B5AE1" />
    <path d="M66.176 277.384H134.675V276.362H66.176V277.384Z" fill="#2B5AE1" />
    <path
      d="M421.746 219.48V221.804C421.746 222.619 422.009 223.283 422.331 223.283H507.149C507.472 223.283 507.734 222.619 507.734 221.804V219.48C507.734 218.667 507.472 218 507.149 218H422.331C422.011 218 421.746 218.667 421.746 219.48Z"
      fill="#9ABFE2"
    />
    <path
      d="M421.746 219.48V221.804C421.746 222.619 421.989 223.283 422.283 223.283H489.62C489.916 223.283 490.157 222.619 490.157 221.804V219.48C490.157 218.667 489.916 218 489.62 218H422.283C421.989 218 421.746 218.667 421.746 219.48Z"
      fill="#2B5AE1"
    />
    <path d="M443.214 311.027H503.431V223.28H443.214V311.027Z" fill="#5F8AD4" />
    <path d="M426.34 311.027H486.557V223.28H426.34V311.027Z" fill="#7DB6FD" />
    <path d="M429.575 225.76H483.32V306.183H429.575V225.76ZM482.737 226.34H430.154V305.603H482.737V226.34Z" fill="#2E49D3" />
    <path d="M483.029 252.364H429.865V252.945H483.029V252.364Z" fill="#2E49D3" />
    <path d="M483.029 279.488H429.865V280.068H483.029V279.488Z" fill="#2E49D3" />
    <path
      d="M451 230.947H460.865C461.344 230.947 461.735 230.556 461.735 230.077C461.735 229.598 461.344 229.208 460.865 229.208H451C450.521 229.208 450.13 229.598 450.13 230.077C450.128 230.554 450.521 230.947 451 230.947Z"
      fill="#2E49D3"
    />
    <path
      d="M451 257.47H460.865C461.344 257.47 461.735 257.08 461.735 256.601C461.735 256.122 461.344 255.731 460.865 255.731H451C450.521 255.731 450.13 256.124 450.13 256.601C450.128 257.077 450.521 257.47 451 257.47Z"
      fill="#2E49D3"
    />
    <path
      d="M451 285.119H460.865C461.344 285.119 461.735 284.728 461.735 284.249C461.735 283.77 461.344 283.379 460.865 283.379H451C450.521 283.379 450.13 283.77 450.13 284.249C450.128 284.726 450.521 285.119 451 285.119Z"
      fill="#2E49D3"
    />
    <path
      d="M445.989 111.542H403.437C403.048 111.542 402.732 111.224 402.732 110.838V69.6065C402.732 69.218 403.05 68.9023 403.437 68.9023H445.989C446.378 68.9023 446.694 69.2202 446.694 69.6065V110.838C446.694 111.227 446.376 111.542 445.989 111.542Z"
      fill="#C0D8FB"
    />
    <path
      d="M444.146 109.695H405.28C404.927 109.695 404.638 109.405 404.638 109.05V71.3902C404.638 71.037 404.927 70.7456 405.28 70.7456H444.146C444.499 70.7456 444.788 71.0348 444.788 71.3902V109.05C444.788 109.405 444.499 109.695 444.146 109.695Z"
      fill="#DFEBFD"
    />
    <path
      d="M423.802 74.6419C423.802 74.1386 424.21 73.7324 424.711 73.7324C425.215 73.7324 425.621 74.1408 425.621 74.6419C425.621 75.1452 425.213 75.5514 424.711 75.5514C424.21 75.5514 423.802 75.1452 423.802 74.6419Z"
      fill="#2E49D3"
    />
    <path
      d="M431.15 75.9288C431.395 75.4895 431.95 75.3306 432.389 75.5756C432.828 75.8207 432.987 76.3747 432.742 76.814C432.497 77.2533 431.943 77.4122 431.504 77.1672C431.064 76.9222 430.907 76.3681 431.15 75.9288Z"
      fill="#2E49D3"
    />
    <path
      d="M437.445 80.929C437.866 80.6575 438.432 80.7789 438.703 81.2005C438.977 81.6221 438.856 82.1872 438.432 82.4588C438.01 82.7303 437.445 82.6089 437.173 82.1873C436.902 81.7656 437.023 81.2005 437.445 80.929Z"
      fill="#2E49D3"
    />
    <path
      d="M440.565 88.6685C441.068 88.6685 441.475 89.0768 441.475 89.5779C441.475 90.0812 441.066 90.4874 440.565 90.4874C440.062 90.4874 439.655 90.079 439.655 89.5779C439.653 89.0746 440.062 88.6685 440.565 88.6685Z"
      fill="#2E49D3"
    />
    <path
      d="M438.973 97.6503C439.328 98.0057 439.328 98.5819 438.973 98.9373C438.617 99.2927 438.041 99.2927 437.686 98.9373C437.33 98.5819 437.33 98.0057 437.686 97.6503C438.041 97.2949 438.617 97.2949 438.973 97.6503Z"
      fill="#2E49D3"
    />
    <path
      d="M433.254 103.381C433.609 103.737 433.609 104.313 433.254 104.668C432.899 105.024 432.322 105.024 431.967 104.668C431.611 104.313 431.611 103.737 431.967 103.381C432.322 103.026 432.899 103.026 433.254 103.381Z"
      fill="#2E49D3"
    />
    <path
      d="M423.802 106.337C423.802 105.834 424.21 105.428 424.711 105.428C425.215 105.428 425.621 105.836 425.621 106.337C425.621 106.841 425.213 107.247 424.711 107.247C424.21 107.247 423.802 106.838 423.802 106.337Z"
      fill="#2E49D3"
    />
    <path
      d="M418.246 75.9288C418.001 75.4895 417.447 75.3306 417.008 75.5756C416.568 75.8207 416.409 76.3747 416.654 76.814C416.899 77.2533 417.454 77.4122 417.893 77.1672C418.332 76.9222 418.491 76.3681 418.246 75.9288Z"
      fill="#2E49D3"
    />
    <path
      d="M411.951 80.9285C411.53 80.657 410.966 80.7784 410.693 81.2C410.421 81.6217 410.543 82.1868 410.964 82.4583C411.386 82.7298 411.951 82.6084 412.223 82.1868C412.494 81.7651 412.373 81.2 411.951 80.9285Z"
      fill="#2E49D3"
    />
    <path
      d="M408.834 88.668C408.33 88.668 407.924 89.0763 407.924 89.5774C407.924 90.0807 408.332 90.4869 408.834 90.4869C409.335 90.4869 409.743 90.0785 409.743 89.5774C409.743 89.0741 409.337 88.668 408.834 88.668Z"
      fill="#2E49D3"
    />
    <path
      d="M410.426 97.6503C410.07 98.0057 410.07 98.5819 410.426 98.9373C410.781 99.2927 411.358 99.2927 411.713 98.9373C412.068 98.5819 412.068 98.0057 411.713 97.6503C411.358 97.2949 410.781 97.2949 410.426 97.6503Z"
      fill="#2E49D3"
    />
    <path
      d="M416.145 103.381C415.789 103.737 415.789 104.313 416.145 104.668C416.5 105.024 417.076 105.024 417.432 104.668C417.787 104.313 417.787 103.737 417.432 103.381C417.076 103.026 416.5 103.026 416.145 103.381Z"
      fill="#2E49D3"
    />
    <path
      d="M424.468 89.5779C424.468 89.0746 424.876 88.6685 425.38 88.6685C425.883 88.6685 426.289 89.0768 426.289 89.5779C426.289 90.0812 425.881 90.4874 425.38 90.4874C424.874 90.4896 424.468 90.0812 424.468 89.5779Z"
      fill="#2E49D3"
    />
    <path d="M425.504 78.2051H425.254V89.5781H425.504V78.2051Z" fill="#2E49D3" />
    <path d="M431.075 84.5292L425.039 89.2583L425.5 89.8448L431.536 85.1158L431.075 84.5292Z" fill="#2E49D3" />
    <path
      d="M164.558 202.575H408.524C410.348 202.575 411.828 201.096 411.828 199.272C411.828 197.449 410.348 195.97 408.524 195.97H164.558C162.734 195.97 161.255 197.449 161.255 199.272C161.255 201.098 162.734 202.575 164.558 202.575Z"
      fill="#77A4E5"
    />
    <path
      d="M171.244 311.362L171.171 311.353C170.308 311.238 169.696 310.404 169.807 309.488L182.949 199.274L190.315 199.504L172.651 310.256C172.538 310.962 171.918 311.452 171.244 311.362Z"
      fill="#77A4E5"
    />
    <path
      d="M402.097 311.362L402.17 311.353C403.033 311.238 403.645 310.404 403.534 309.488L390.392 199.274L383.026 199.504L400.69 310.256C400.803 310.962 401.423 311.452 402.097 311.362Z"
      fill="#77A4E5"
    />
    <path
      d="M531.979 313H53.0211C53.0096 313 53 312.985 53 312.967V311.033C53 311.015 53.0096 311 53.0211 311H531.979C531.99 311 532 311.015 532 311.033V312.967C532 312.985 531.99 313 531.979 313Z"
      fill="#333333"
    />
    <g clip-path="url(#clip0_386_2099)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M308.482 32.8788C288.177 21.1516 262.218 28.1099 250.495 48.422C249.974 49.2897 249.133 49.918 248.153 50.1715C247.173 50.4249 246.133 50.2834 245.257 49.7773C244.381 49.2711 243.738 48.4409 243.468 47.4655C243.197 46.49 243.321 45.4474 243.812 44.5621C257.662 20.5583 288.348 12.333 312.34 26.1932C313.207 26.7145 313.835 27.5558 314.089 28.5358C314.342 29.5158 314.201 30.5561 313.695 31.4328C313.189 32.3094 312.359 32.9522 311.384 33.2226C310.409 33.4931 309.367 33.3697 308.482 32.8788ZM300.764 46.25C297.692 44.4754 294.3 43.3235 290.783 42.8602C287.266 42.3968 283.692 42.6311 280.265 43.5497C276.838 44.4682 273.625 46.0531 270.811 48.2136C267.996 50.3742 265.635 53.0682 263.861 56.1419C263.34 57.0096 262.499 57.6378 261.519 57.8913C260.54 58.1448 259.5 58.0032 258.623 57.4971C257.747 56.991 257.105 56.1608 256.834 55.1854C256.564 54.2099 256.687 53.1672 257.178 52.2819C259.458 48.3305 262.495 44.867 266.113 42.0894C269.732 39.3117 273.862 37.2743 278.267 36.0933C282.673 34.9124 287.268 34.6111 291.79 35.2067C296.312 35.8023 300.673 37.283 304.623 39.5644C305.49 40.0857 306.118 40.927 306.372 41.907C306.625 42.887 306.484 43.9273 305.978 44.804C305.472 45.6806 304.642 46.3234 303.667 46.5939C302.692 46.8643 301.649 46.7409 300.764 46.25ZM293.042 59.6307C290.383 58.0956 287.224 57.6797 284.258 58.4746C281.293 59.2694 278.765 61.2099 277.229 63.8692C276.717 64.7564 275.874 65.4038 274.885 65.6689C273.896 65.9341 272.842 65.7953 271.955 65.283C271.068 64.7708 270.421 63.9271 270.156 62.9376C269.891 61.9481 270.029 60.8937 270.541 60.0065C271.808 57.8108 273.495 55.8862 275.506 54.3426C277.516 52.7991 279.811 51.6669 282.259 51.0108C284.707 50.3546 287.26 50.1873 289.773 50.5184C292.286 50.8494 294.709 51.6724 296.903 52.9404C297.79 53.4526 298.437 54.2963 298.702 55.2858C298.967 56.2753 298.829 57.3297 298.317 58.2169C297.804 59.1041 296.961 59.7514 295.972 60.0166C294.983 60.2817 293.929 60.1429 293.042 59.6307ZM283.529 70.6536C283.264 69.6646 283.403 68.6108 283.915 67.7241C284.427 66.8374 285.269 66.1904 286.258 65.9254L286.295 65.9154C287.284 65.6504 288.337 65.7891 289.224 66.3011C290.11 66.813 290.757 67.6562 291.022 68.6452C291.287 69.6342 291.148 70.688 290.636 71.5747C290.124 72.4614 289.282 73.1084 288.293 73.3734L288.256 73.3834C287.267 73.6484 286.214 73.5096 285.327 72.9977C284.441 72.4858 283.794 71.6425 283.529 70.6536Z"
        fill="#51BC86"
      />
    </g>
    <defs>
      <clipPath id="clip0_386_2099">
        <rect width="77.1842" height="77.2085" fill="white" transform="matrix(0.965902 -0.258907 0.258731 0.965949 234 19.9834)" />
      </clipPath>
    </defs>
  </svg>
);

export const BackgroundCurvedShapeSvg = ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="1440" height="418" viewBox="0 0 1440 518" fill="none">
    <path
      d="M57.3535 -593.526C57.3535 -593.526 -148.413 -477.893 -118.569 -264.804C-96.6253 -108.148 35.6904 2.94403 247.694 0.96104C445.249 -0.890065 648.078 65.7337 787.351 329.519C949.892 637.376 1452.94 545.556 1448.12 211.436C1444.94 -8.51976 1752.28 29.6808 1646.35 -343.195L57.3535 -593.526Z"
      fill="#ECF6FF"
    />
  </svg>
);

export const BulletListCheckmarkSvg = ({ className }) => (
  <svg className={className} style={{ marginRight: "10px" }} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g clip-path="url(#clip0_386_2213)">
      <path
        d="M5.4343 13.7312L0.234305 8.53123C-0.0781016 8.21883 -0.0781016 7.7123 0.234305 7.39986L1.36565 6.26848C1.67805 5.95605 2.18462 5.95605 2.49702 6.26848L5.99999 9.77142L13.503 2.26848C13.8154 1.95608 14.3219 1.95608 14.6343 2.26848L15.7657 3.39986C16.0781 3.71227 16.0781 4.2188 15.7657 4.53123L6.56568 13.7313C6.25324 14.0437 5.74671 14.0437 5.4343 13.7312Z"
        fill="#51BC86"
      />
    </g>
    <defs>
      <clipPath id="clip0_386_2213">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const BulletListEllipse = ({ className }) => (
  <svg className={className} style={{ marginRight: "10px" }} xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none">
    <circle cx="3" cy="3" r="3" fill="#C4C4C4" />
  </svg>
);

export const HomeSection3BackgroundShapeSvg = ({ className }) => (
  <svg className={className} width="403" height="499" viewBox="0 0 403 499" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="-322" width="725" height="499" rx="249.5" fill="#668DB0" />
  </svg>
);

export const WhiteDotGridSvg = ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="184" height="92" viewBox="0 0 184 92" fill="none">
    <g clip-path="url(#clip0_386_2238)">
      <path
        d="M182.324 91.002C182.803 91.002 183.192 90.6098 183.192 90.126C183.192 89.6422 182.803 89.25 182.324 89.25C181.844 89.25 181.455 89.6422 181.455 90.126C181.455 90.6098 181.844 91.002 182.324 91.002Z"
        fill="white"
      />
      <path
        d="M162.162 91.002C162.642 91.002 163.031 90.6098 163.031 90.126C163.031 89.6422 162.642 89.25 162.162 89.25C161.683 89.25 161.294 89.6422 161.294 90.126C161.294 90.6098 161.683 91.002 162.162 91.002Z"
        fill="white"
      />
      <path
        d="M142 91.002C142.48 91.002 142.869 90.6098 142.869 90.126C142.869 89.6422 142.48 89.25 142 89.25C141.521 89.25 141.132 89.6422 141.132 90.126C141.132 90.6098 141.521 91.002 142 91.002Z"
        fill="white"
      />
      <path
        d="M121.838 91.002C122.318 91.002 122.707 90.6098 122.707 90.126C122.707 89.6422 122.318 89.25 121.838 89.25C121.359 89.25 120.97 89.6422 120.97 90.126C120.97 90.6098 121.359 91.002 121.838 91.002Z"
        fill="white"
      />
      <path
        d="M101.677 91.002C102.157 91.002 102.545 90.6098 102.545 90.126C102.545 89.6422 102.157 89.25 101.677 89.25C101.197 89.25 100.809 89.6422 100.809 90.126C100.809 90.6098 101.197 91.002 101.677 91.002Z"
        fill="white"
      />
      <path
        d="M81.514 91.002C81.9936 91.002 82.3824 90.6098 82.3824 90.126C82.3824 89.6422 81.9936 89.25 81.514 89.25C81.0343 89.25 80.6455 89.6422 80.6455 90.126C80.6455 90.6098 81.0343 91.002 81.514 91.002Z"
        fill="white"
      />
      <path
        d="M61.3538 91.002C61.8334 91.002 62.2223 90.6098 62.2223 90.126C62.2223 89.6422 61.8334 89.25 61.3538 89.25C60.8742 89.25 60.4854 89.6422 60.4854 90.126C60.4854 90.6098 60.8742 91.002 61.3538 91.002Z"
        fill="white"
      />
      <path
        d="M41.1917 91.002C41.6713 91.002 42.0601 90.6098 42.0601 90.126C42.0601 89.6422 41.6713 89.25 41.1917 89.25C40.7121 89.25 40.3232 89.6422 40.3232 90.126C40.3232 90.6098 40.7121 91.002 41.1917 91.002Z"
        fill="white"
      />
      <path
        d="M21.0286 91.002C21.5082 91.002 21.8971 90.6098 21.8971 90.126C21.8971 89.6422 21.5082 89.25 21.0286 89.25C20.549 89.25 20.1602 89.6422 20.1602 90.126C20.1602 90.6098 20.549 91.002 21.0286 91.002Z"
        fill="white"
      />
      <path
        d="M0.868449 91.002C1.34808 91.002 1.7369 90.6098 1.7369 90.126C1.7369 89.6422 1.34808 89.25 0.868449 89.25C0.388818 89.25 0 89.6422 0 90.126C0 90.6098 0.388818 91.002 0.868449 91.002Z"
        fill="white"
      />
      <path
        d="M182.324 72.6817C182.803 72.6817 183.192 72.2895 183.192 71.8057C183.192 71.3219 182.803 70.9297 182.324 70.9297C181.844 70.9297 181.455 71.3219 181.455 71.8057C181.455 72.2895 181.844 72.6817 182.324 72.6817Z"
        fill="white"
      />
      <path
        d="M162.162 72.6817C162.642 72.6817 163.031 72.2895 163.031 71.8057C163.031 71.3219 162.642 70.9297 162.162 70.9297C161.683 70.9297 161.294 71.3219 161.294 71.8057C161.294 72.2895 161.683 72.6817 162.162 72.6817Z"
        fill="white"
      />
      <path
        d="M142 72.6817C142.48 72.6817 142.869 72.2895 142.869 71.8057C142.869 71.3219 142.48 70.9297 142 70.9297C141.521 70.9297 141.132 71.3219 141.132 71.8057C141.132 72.2895 141.521 72.6817 142 72.6817Z"
        fill="white"
      />
      <path
        d="M121.838 72.6817C122.318 72.6817 122.707 72.2895 122.707 71.8057C122.707 71.3219 122.318 70.9297 121.838 70.9297C121.359 70.9297 120.97 71.3219 120.97 71.8057C120.97 72.2895 121.359 72.6817 121.838 72.6817Z"
        fill="white"
      />
      <path
        d="M101.677 72.6817C102.157 72.6817 102.545 72.2895 102.545 71.8057C102.545 71.3219 102.157 70.9297 101.677 70.9297C101.197 70.9297 100.809 71.3219 100.809 71.8057C100.809 72.2895 101.197 72.6817 101.677 72.6817Z"
        fill="white"
      />
      <path
        d="M81.514 72.6817C81.9936 72.6817 82.3824 72.2895 82.3824 71.8057C82.3824 71.3219 81.9936 70.9297 81.514 70.9297C81.0343 70.9297 80.6455 71.3219 80.6455 71.8057C80.6455 72.2895 81.0343 72.6817 81.514 72.6817Z"
        fill="white"
      />
      <path
        d="M61.3538 72.6817C61.8334 72.6817 62.2223 72.2895 62.2223 71.8057C62.2223 71.3219 61.8334 70.9297 61.3538 70.9297C60.8742 70.9297 60.4854 71.3219 60.4854 71.8057C60.4854 72.2895 60.8742 72.6817 61.3538 72.6817Z"
        fill="white"
      />
      <path
        d="M41.1917 72.6817C41.6713 72.6817 42.0601 72.2895 42.0601 71.8057C42.0601 71.3219 41.6713 70.9297 41.1917 70.9297C40.7121 70.9297 40.3232 71.3219 40.3232 71.8057C40.3232 72.2895 40.7121 72.6817 41.1917 72.6817Z"
        fill="white"
      />
      <path
        d="M21.0286 72.6817C21.5082 72.6817 21.8971 72.2895 21.8971 71.8057C21.8971 71.3219 21.5082 70.9297 21.0286 70.9297C20.549 70.9297 20.1602 71.3219 20.1602 71.8057C20.1602 72.2895 20.549 72.6817 21.0286 72.6817Z"
        fill="white"
      />
      <path
        d="M0.868449 72.6817C1.34808 72.6817 1.7369 72.2895 1.7369 71.8057C1.7369 71.3219 1.34808 70.9297 0.868449 70.9297C0.388818 70.9297 0 71.3219 0 71.8057C0 72.2895 0.388818 72.6817 0.868449 72.6817Z"
        fill="white"
      />
      <path
        d="M182.324 56.8585C182.803 56.8585 183.192 56.4663 183.192 55.9825C183.192 55.4986 182.803 55.1064 182.324 55.1064C181.844 55.1064 181.455 55.4986 181.455 55.9825C181.455 56.4663 181.844 56.8585 182.324 56.8585Z"
        fill="white"
      />
      <path
        d="M162.162 56.8585C162.642 56.8585 163.031 56.4663 163.031 55.9825C163.031 55.4986 162.642 55.1064 162.162 55.1064C161.683 55.1064 161.294 55.4986 161.294 55.9825C161.294 56.4663 161.683 56.8585 162.162 56.8585Z"
        fill="white"
      />
      <path
        d="M142 56.8585C142.48 56.8585 142.869 56.4663 142.869 55.9825C142.869 55.4986 142.48 55.1064 142 55.1064C141.521 55.1064 141.132 55.4986 141.132 55.9825C141.132 56.4663 141.521 56.8585 142 56.8585Z"
        fill="white"
      />
      <path
        d="M121.838 56.8585C122.318 56.8585 122.707 56.4663 122.707 55.9825C122.707 55.4986 122.318 55.1064 121.838 55.1064C121.359 55.1064 120.97 55.4986 120.97 55.9825C120.97 56.4663 121.359 56.8585 121.838 56.8585Z"
        fill="white"
      />
      <path
        d="M101.677 56.8585C102.157 56.8585 102.545 56.4663 102.545 55.9825C102.545 55.4986 102.157 55.1064 101.677 55.1064C101.197 55.1064 100.809 55.4986 100.809 55.9825C100.809 56.4663 101.197 56.8585 101.677 56.8585Z"
        fill="white"
      />
      <path
        d="M81.514 56.8585C81.9936 56.8585 82.3824 56.4663 82.3824 55.9825C82.3824 55.4986 81.9936 55.1064 81.514 55.1064C81.0343 55.1064 80.6455 55.4986 80.6455 55.9825C80.6455 56.4663 81.0343 56.8585 81.514 56.8585Z"
        fill="white"
      />
      <path
        d="M61.3538 56.8585C61.8334 56.8585 62.2223 56.4663 62.2223 55.9825C62.2223 55.4986 61.8334 55.1064 61.3538 55.1064C60.8742 55.1064 60.4854 55.4986 60.4854 55.9825C60.4854 56.4663 60.8742 56.8585 61.3538 56.8585Z"
        fill="white"
      />
      <path
        d="M41.1917 56.8585C41.6713 56.8585 42.0601 56.4663 42.0601 55.9825C42.0601 55.4986 41.6713 55.1064 41.1917 55.1064C40.7121 55.1064 40.3232 55.4986 40.3232 55.9825C40.3232 56.4663 40.7121 56.8585 41.1917 56.8585Z"
        fill="white"
      />
      <path
        d="M21.0286 56.8585C21.5082 56.8585 21.8971 56.4663 21.8971 55.9825C21.8971 55.4986 21.5082 55.1064 21.0286 55.1064C20.549 55.1064 20.1602 55.4986 20.1602 55.9825C20.1602 56.4663 20.549 56.8585 21.0286 56.8585Z"
        fill="white"
      />
      <path
        d="M0.868449 56.8585C1.34808 56.8585 1.7369 56.4663 1.7369 55.9825C1.7369 55.4986 1.34808 55.1064 0.868449 55.1064C0.388818 55.1064 0 55.4986 0 55.9825C0 56.4663 0.388818 56.8585 0.868449 56.8585Z"
        fill="white"
      />
      <path
        d="M182.324 38.5372C182.803 38.5372 183.192 38.145 183.192 37.6612C183.192 37.1774 182.803 36.7852 182.324 36.7852C181.844 36.7852 181.455 37.1774 181.455 37.6612C181.455 38.145 181.844 38.5372 182.324 38.5372Z"
        fill="white"
      />
      <path
        d="M162.162 38.5372C162.642 38.5372 163.031 38.145 163.031 37.6612C163.031 37.1774 162.642 36.7852 162.162 36.7852C161.683 36.7852 161.294 37.1774 161.294 37.6612C161.294 38.145 161.683 38.5372 162.162 38.5372Z"
        fill="white"
      />
      <path
        d="M142 38.5372C142.48 38.5372 142.869 38.145 142.869 37.6612C142.869 37.1774 142.48 36.7852 142 36.7852C141.521 36.7852 141.132 37.1774 141.132 37.6612C141.132 38.145 141.521 38.5372 142 38.5372Z"
        fill="white"
      />
      <path
        d="M121.838 38.5372C122.318 38.5372 122.707 38.145 122.707 37.6612C122.707 37.1774 122.318 36.7852 121.838 36.7852C121.359 36.7852 120.97 37.1774 120.97 37.6612C120.97 38.145 121.359 38.5372 121.838 38.5372Z"
        fill="white"
      />
      <path
        d="M101.677 38.5372C102.157 38.5372 102.545 38.145 102.545 37.6612C102.545 37.1774 102.157 36.7852 101.677 36.7852C101.197 36.7852 100.809 37.1774 100.809 37.6612C100.809 38.145 101.197 38.5372 101.677 38.5372Z"
        fill="white"
      />
      <path
        d="M81.514 38.5372C81.9936 38.5372 82.3824 38.145 82.3824 37.6612C82.3824 37.1774 81.9936 36.7852 81.514 36.7852C81.0343 36.7852 80.6455 37.1774 80.6455 37.6612C80.6455 38.145 81.0343 38.5372 81.514 38.5372Z"
        fill="white"
      />
      <path
        d="M61.3538 38.5372C61.8334 38.5372 62.2223 38.145 62.2223 37.6612C62.2223 37.1774 61.8334 36.7852 61.3538 36.7852C60.8742 36.7852 60.4854 37.1774 60.4854 37.6612C60.4854 38.145 60.8742 38.5372 61.3538 38.5372Z"
        fill="white"
      />
      <path
        d="M41.1917 38.5372C41.6713 38.5372 42.0601 38.145 42.0601 37.6612C42.0601 37.1774 41.6713 36.7852 41.1917 36.7852C40.7121 36.7852 40.3232 37.1774 40.3232 37.6612C40.3232 38.145 40.7121 38.5372 41.1917 38.5372Z"
        fill="white"
      />
      <path
        d="M21.0286 38.5372C21.5082 38.5372 21.8971 38.145 21.8971 37.6612C21.8971 37.1774 21.5082 36.7852 21.0286 36.7852C20.549 36.7852 20.1602 37.1774 20.1602 37.6612C20.1602 38.145 20.549 38.5372 21.0286 38.5372Z"
        fill="white"
      />
      <path
        d="M0.868449 38.5372C1.34808 38.5372 1.7369 38.145 1.7369 37.6612C1.7369 37.1774 1.34808 36.7852 0.868449 36.7852C0.388818 36.7852 0 37.1774 0 37.6612C0 38.145 0.388818 38.5372 0.868449 38.5372Z"
        fill="white"
      />
      <path
        d="M182.324 20.2168C182.803 20.2168 183.192 19.8246 183.192 19.3408C183.192 18.857 182.803 18.4648 182.324 18.4648C181.844 18.4648 181.455 18.857 181.455 19.3408C181.455 19.8246 181.844 20.2168 182.324 20.2168Z"
        fill="white"
      />
      <path
        d="M162.162 20.2168C162.642 20.2168 163.031 19.8246 163.031 19.3408C163.031 18.857 162.642 18.4648 162.162 18.4648C161.683 18.4648 161.294 18.857 161.294 19.3408C161.294 19.8246 161.683 20.2168 162.162 20.2168Z"
        fill="white"
      />
      <path
        d="M142 20.2168C142.48 20.2168 142.869 19.8246 142.869 19.3408C142.869 18.857 142.48 18.4648 142 18.4648C141.521 18.4648 141.132 18.857 141.132 19.3408C141.132 19.8246 141.521 20.2168 142 20.2168Z"
        fill="white"
      />
      <path
        d="M121.838 20.2168C122.318 20.2168 122.707 19.8246 122.707 19.3408C122.707 18.857 122.318 18.4648 121.838 18.4648C121.359 18.4648 120.97 18.857 120.97 19.3408C120.97 19.8246 121.359 20.2168 121.838 20.2168Z"
        fill="white"
      />
      <path
        d="M101.677 20.2168C102.157 20.2168 102.545 19.8246 102.545 19.3408C102.545 18.857 102.157 18.4648 101.677 18.4648C101.197 18.4648 100.809 18.857 100.809 19.3408C100.809 19.8246 101.197 20.2168 101.677 20.2168Z"
        fill="white"
      />
      <path
        d="M81.514 20.2168C81.9936 20.2168 82.3824 19.8246 82.3824 19.3408C82.3824 18.857 81.9936 18.4648 81.514 18.4648C81.0343 18.4648 80.6455 18.857 80.6455 19.3408C80.6455 19.8246 81.0343 20.2168 81.514 20.2168Z"
        fill="white"
      />
      <path
        d="M61.3538 20.2168C61.8334 20.2168 62.2223 19.8246 62.2223 19.3408C62.2223 18.857 61.8334 18.4648 61.3538 18.4648C60.8742 18.4648 60.4854 18.857 60.4854 19.3408C60.4854 19.8246 60.8742 20.2168 61.3538 20.2168Z"
        fill="white"
      />
      <path
        d="M41.1917 20.2168C41.6713 20.2168 42.0601 19.8246 42.0601 19.3408C42.0601 18.857 41.6713 18.4648 41.1917 18.4648C40.7121 18.4648 40.3232 18.857 40.3232 19.3408C40.3232 19.8246 40.7121 20.2168 41.1917 20.2168Z"
        fill="white"
      />
      <path
        d="M21.0286 20.2168C21.5082 20.2168 21.8971 19.8246 21.8971 19.3408C21.8971 18.857 21.5082 18.4648 21.0286 18.4648C20.549 18.4648 20.1602 18.857 20.1602 19.3408C20.1602 19.8246 20.549 20.2168 21.0286 20.2168Z"
        fill="white"
      />
      <path
        d="M0.868449 20.2168C1.34808 20.2168 1.7369 19.8246 1.7369 19.3408C1.7369 18.857 1.34808 18.4648 0.868449 18.4648C0.388818 18.4648 0 18.857 0 19.3408C0 19.8246 0.388818 20.2168 0.868449 20.2168Z"
        fill="white"
      />
      <path
        d="M182.324 1.89655C182.803 1.89655 183.192 1.50434 183.192 1.02054C183.192 0.536735 182.803 0.144531 182.324 0.144531C181.844 0.144531 181.455 0.536735 181.455 1.02054C181.455 1.50434 181.844 1.89655 182.324 1.89655Z"
        fill="white"
      />
      <path
        d="M162.162 1.89655C162.642 1.89655 163.031 1.50434 163.031 1.02054C163.031 0.536735 162.642 0.144531 162.162 0.144531C161.683 0.144531 161.294 0.536735 161.294 1.02054C161.294 1.50434 161.683 1.89655 162.162 1.89655Z"
        fill="white"
      />
      <path
        d="M142 1.89655C142.48 1.89655 142.869 1.50434 142.869 1.02054C142.869 0.536735 142.48 0.144531 142 0.144531C141.521 0.144531 141.132 0.536735 141.132 1.02054C141.132 1.50434 141.521 1.89655 142 1.89655Z"
        fill="white"
      />
      <path
        d="M121.838 1.89655C122.318 1.89655 122.707 1.50434 122.707 1.02054C122.707 0.536735 122.318 0.144531 121.838 0.144531C121.359 0.144531 120.97 0.536735 120.97 1.02054C120.97 1.50434 121.359 1.89655 121.838 1.89655Z"
        fill="white"
      />
      <path
        d="M101.677 1.89655C102.157 1.89655 102.545 1.50434 102.545 1.02054C102.545 0.536735 102.157 0.144531 101.677 0.144531C101.197 0.144531 100.809 0.536735 100.809 1.02054C100.809 1.50434 101.197 1.89655 101.677 1.89655Z"
        fill="white"
      />
      <path
        d="M81.514 1.89655C81.9936 1.89655 82.3824 1.50434 82.3824 1.02054C82.3824 0.536735 81.9936 0.144531 81.514 0.144531C81.0343 0.144531 80.6455 0.536735 80.6455 1.02054C80.6455 1.50434 81.0343 1.89655 81.514 1.89655Z"
        fill="white"
      />
      <path
        d="M61.3538 1.89655C61.8334 1.89655 62.2223 1.50434 62.2223 1.02054C62.2223 0.536735 61.8334 0.144531 61.3538 0.144531C60.8742 0.144531 60.4854 0.536735 60.4854 1.02054C60.4854 1.50434 60.8742 1.89655 61.3538 1.89655Z"
        fill="white"
      />
      <path
        d="M41.1917 1.89655C41.6713 1.89655 42.0601 1.50434 42.0601 1.02054C42.0601 0.536735 41.6713 0.144531 41.1917 0.144531C40.7121 0.144531 40.3232 0.536735 40.3232 1.02054C40.3232 1.50434 40.7121 1.89655 41.1917 1.89655Z"
        fill="white"
      />
      <path
        d="M21.0286 1.89655C21.5082 1.89655 21.8971 1.50434 21.8971 1.02054C21.8971 0.536735 21.5082 0.144531 21.0286 0.144531C20.549 0.144531 20.1602 0.536735 20.1602 1.02054C20.1602 1.50434 20.549 1.89655 21.0286 1.89655Z"
        fill="white"
      />
      <path
        d="M0.868449 1.89655C1.34808 1.89655 1.7369 1.50434 1.7369 1.02054C1.7369 0.536735 1.34808 0.144531 0.868449 0.144531C0.388818 0.144531 0 0.536735 0 1.02054C0 1.50434 0.388818 1.89655 0.868449 1.89655Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_386_2238">
        <rect width="184" height="92" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const HomeSection4BackgroundShapeSvg = ({ className }) => (
  <svg className={className} width="401" height="499" viewBox="0 0 401 499" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="637" height="499" rx="249.5" transform="matrix(-1 0 0 1 637 0)" fill="#51BC86" />
  </svg>
);

export const HomeSection5BackgroundShapeSvg = ({ className }) => (
  <svg className={className} width="403" height="499" viewBox="0 0 403 499" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="-322" width="725" height="499" rx="249.5" fill="#FDDE59" />
  </svg>
);

export const HomeBannerCurveShapeSVG = ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="1000" height="118" viewBox="0 0 1000 118" fill="none">
    <path
      d="M166.707 57.8784C206.611 43.4873 249.157 37.9018 291.424 41.5055L716.844 77.7769C754.651 81.0003 792.706 75.9096 828.336 62.862L1000 0V110C1000 114.418 996.418 118 992 118H0L166.707 57.8784Z"
      fill="white"
      fill-opacity="0.1"
    />
  </svg>
);